var Payment = xClass("BaiduLightgamePayment")
Payment.prototype.ctor = function () {

}

/**
 * 百度接口错误码转义
 * @param {Number} errCode 错误码
 * @returns {String} 错误信息的中文描述
 * @see https://developers.weixin.qq.com/miniprogram/document/midas-payment/requestMidasPayment.html?t=201812
 * @todo 修改为从strings配置中读取
 */
Payment.prototype.errCodeToMsg = function (res) {
    if (res && (res.errCode == 6)) //errCode = 6, errMsg:"防沉迷：real_name_success" 
    {
        return "完成实名认证后才能购买商品哦！";
    }

    return res ? res.errMsg : "";
}
// 获取失败类型
Payment.prototype.getFailType = function (errCode) {
    let fail_type = 1;
    if (errCode == 2){
        fail_type = -1;
    }
    return fail_type;
}

Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    let productId = data.productId

    function onSuccess(res) {
        
        let orderId = res.data && res.data.orderId;
        cc.log("[Payment]BaiduLightgamePayment res",res.data)
        cc.log("[Payment]BaiduLightgamePayment orderId",orderId)
        cc.log("[Payment]BaiduLightgamePayment res.data.price",res.data.price)
        cc.log("[Payment]BaiduLightgamePayment res.data.rsaSign",res.data.rsaSign)
        cc.log("[Payment]BaiduLightgamePayment 新支付")

        mini.pay({
            orderInfo: {
                dealId: "1912794608",
                appKey: "MMm4An",
                totalAmount: res.data.price*100, 
                tpOrderId: res.data.orderId,
                dealTitle: "购买商品",
                rsaSign: res.data.rsaSign,
                signFieldsRange: 1
            },
            bannedChannels: ['ApplePay'],
            success: function() {
                successCallback && successCallback( { orderId } )
            },
            fail: res => {
                console.log("[######]fail res:"+JSON.stringify(res))
                let fail_type = self.getFailType(res.errCode);
                let fail_msg = self.errCodeToMsg(res);
                failCallback({
                    code: res ? res.errCode : "",
                    data: fail_msg,
                    type: fail_type,//1代表是第三方掉起支付失败
                })
            }
        });
    }

    function onFail(evt) {
        cc.log("[################]getinfohttp failed" + evt.data)
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.log("[################]getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = BaidulightgamePaymentGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        productId: productId,
        zoneId: META.user.serverid,
        openid: META.user.openid,
        sessionid: META.user.sessionid,
        ext: data.ext

    })
}

module.exports = Payment